import { useEffect, useState } from 'react';

import LS from '.';

export enum LocalCacheEnum {
  AISEE_FEEDBACK_LIST_FULLSCREEN = 'aisee-feedback-list-fullscreen',
  AISEE_HIDDEN_LIST_OPERATE = 'hidden-list-operate',
  AISEE_HIDDEN_AI_LIST_OPERATE = 'hidden-ai-list-operate',
  AISEE_USE_LLM_MODAL_NAME = 'aisee-use-llmmodel_name',
  AISEE_ISSUE_EXPAND_FIELD = 'aisee-issue-expand-field',
  AISEE_EXPLORATION_HIDE_STEPPER = 'aisee-exploration-hide-stepper',
  AISEE_OPEN_THINKS = 'aisee-open-thinks',
  AISEE_PUBLIC_OPINION_SETTINGS = 'aisee-public-opinion-settings',
  AISEE_OPINION_SELECTED_TOPIC = 'aisee-opinion-selected-topic',
  AISEE_ISSUE_FOLLOW_VIEW = 'aisee-issue-follow-view',
  AISEE_OPINION_SINA_OAUTH_INFO = 'aisee-opinion-sina-oauth-info',
  AISEE_FEEDBACK_DETAIL_OPERATE = 'aisee-feedback-detail-operate',
  AISEE_GIT_OAUTH_CODE = 'aisee-git-oauth-code',
  AISEE_GIT_ACCESS_TOKEN = 'aisee-git-access-token',
  AISEE_GIT_REFRESH_TOKEN = 'aisee-git-refresh-token',
  AISEE_SYNC_TARGET_APP_IDS = 'aisee-sync-target-app-ids',
}

/**
 * 自定义 Hook，用于观测 localStorage 中的变量
 * @param key - localStorage 中的键名
 * @param defaultValue - 默认值
 * @returns [value, setValue] - 返回当前值和更新值的函数
 */
const useLocalStorage = <T,>(
  key: LocalCacheEnum,
  defaultValue?: T
): [T, (newValue: T) => void] => {
  const [value, setValue] = useState<T>(() => {
    const storedValue = LS.get(key);
    return storedValue !== null ? storedValue : defaultValue;
  });

  useEffect(() => {
    // 定义处理自定义事件的函数
    const handleStorageChange = (e: CustomEvent) => {
      if (e.detail.key === key) {
        setValue(e.detail.newValue);
      }
    };

    window.addEventListener<any>('storageChange', handleStorageChange);

    // 清理函数，移除监听器
    return () => {
      window.removeEventListener<any>('storageChange', handleStorageChange);
    };
  }, [key]);

  const setLocalStorageValue = (newValue: T) => {
    LS.set(key, newValue);
    setValue(newValue);

    // 创建并触发自定义事件
    const event = new CustomEvent('storageChange', {
      detail: { key, newValue },
    });
    window.dispatchEvent(event);
  };

  return [value, setLocalStorageValue];
};

export default useLocalStorage;
